// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__31qi5","title":"AfterFrontImage_title__sgZgJ"};